var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { authManager } from 'utils/auth/authManager';
/** A hook that resolves the auth data from the local storage. */
export const useAuthLocalStorage = () => {
    const getAuthDataFromLocalStorage = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const authData = authManager.getAuthFromStorageOnly();
        return authData && authManager.validateAuthDataComplete(authData)
            ? Promise.resolve({
                type: 'localStorage',
                asyncStatus: 'fulfilled',
                authData,
            })
            : Promise.reject();
    }), []);
    /** Triggers the retrieval of the auth data in a promise. */
    const trigger = useCallback(() => {
        return getAuthDataFromLocalStorage();
    }, [getAuthDataFromLocalStorage]);
    return trigger;
};
